<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>派车管理</h4>
      <div @click="backClick"><i class="fa fa-reply"></i></div>
    </div>
    <div style="width:60%;display: flex;justify-content: space-between;margin:10px 10px 10px 10px;">
      <span >客户名称：<span>{{plan.customerName}}</span></span>
      <span v-if="plan.flowtoType == '1'">流向：<span>外发</span></span>
      <span v-if="plan.flowtoType == '2'">流向：<span>集港</span></span>
      <span v-if="plan.flowtoType == '3'">流向：<span>倒中钢库</span></span>
      <span v-if="plan.flowtoType == '4'">流向：<span>倒兴泰库</span></span>
      <span >
        合同号：
        <span v-if="plan.flowtoType != '1' && plan.weightFlg == 'T'">理计合同</span>
        <span v-else>{{plan.contractNo}}</span>
      </span>
      <span >未完成：<span style="color:red;">{{surplusWeight}}</span> 吨</span>
    </div>
    <div>
      <span>
          <div style="display: flex;margin-left:10px;">
            <span >可发库存：<span>{{keFaKuCun}}</span>吨</span>
            <span style="margin-left:50px;">可装配量：<span>{{keZhuangPei}}</span>吨</span>
          </div>
        <div class="addinpBox">
                <el-table
                  :data="cargoInfoList"
                  ref="cargoInfoList"
                  border
                  height="200"
                  bordersize="mini"
                  style="width:100%;margin-top:10px;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column prop="wareHouse"    label="垛位" align="center" width="200"></el-table-column>
                  <el-table-column prop="inventory"   label="可发库存" align="center"  ></el-table-column>
                  <el-table-column prop="availableInventory"   label="可装配量" align="center"  ></el-table-column>
                  <!-- <el-table-column prop="availableContractString"   label="可装配合同" align="center"  ></el-table-column> -->
                  <el-table-column prop="carCount" label="待发车数"  align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="" label="操作"  align="center" >
                    <template slot-scope="scope"><div>
                        <el-button @click="kuCunDetails(scope.row)" btnCode='00DP001B00H' v-if="btnFlg[0]" type="text" size="small" >库存详情</el-button>
                      </div></template>
                  </el-table-column>
                </el-table>
        </div>
      </span>
      <!--运单情况-->
    <div>
      <span>
          <div style="display: flex;">
          <div class="titleText">
              已选车辆：
          </div>
          <div>
              <el-button type="primary" size="mini" @click="xuanZeCheLiang">选择车辆</el-button>
          </div>
          </div>
        <div class="addinpBox">
                <el-table
                  :data="tableList"
                  ref="table"
                  border
                  bordersize="mini"
                  style="width:100%;margin-top:10px;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column prop="vehicleNo"   label="车号" align="center"  width="120"></el-table-column>
                  <el-table-column prop="vehicleCarry"    label="载重（吨）" align="center" width="120"></el-table-column>
                  <el-table-column prop="fleetName" label="车队"  align="center" ></el-table-column>
                  <el-table-column prop="driverName" label="司机"  align="center" ></el-table-column>
                  <el-table-column prop="positions"   label="分配垛位" align="center"  width="220">
                     <template slot-scope="scope">
                      <el-select v-model="scope.row.positions" multiple  placeholder="请选择" size="mini">
                        <el-option
                            v-for="(item,index) in dropDownCargoList"
                            :key="index"
                            :label="item"
                            :value="item">
                        </el-option>
                        </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="driverStatusName" label="状态"  align="center" ></el-table-column>
                  <el-table-column prop="firstTareTime" label="一检时间"  align="center" width="200"></el-table-column>
                   <el-table-column  label="操作"  align="center" >
                     <template slot-scope="scope">
                      <el-button @click="delClick(scope.$index, tableList)" type="text" size="small">删除</el-button>
                    </template>
                   </el-table-column>
                </el-table>
        </div>
      </span>
    </div>
    <!--选择车辆-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="cheLiangMark"
    @close="closeDialog"
    width="900px"
    center>
      <span>
        <div class="addinpBox">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>车队：</span>
                <el-select v-model="waybillForm.fleetCode" placeholder="请选择" size="mini" style="width:150px;">
                    <el-option
                        v-for="(item,index) in fleetOptions"
                        :key="index"
                        :label="item.tenantName"
                        :value="item.tenantCode">
                      </el-option>
                </el-select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>车牌：</span>
                  <el-input  placeholder="" maxlength="100" v-model="waybillForm.vehicleNo" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <el-button type="primary" size="mini" @click="carSearchClick">查询</el-button>
                <el-table
                  :data="carTableList"
                  ref="carTabRef"
                  border
                  bordersize="mini"
                  @selection-change="handleSelectionChange"
                  style="width:95%;margin-top:10px;margin-left:4%;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column  type="index" prop="" width="55" label="序号" align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="vehicleNo"    label="车号" align="center" width="120" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="fleetName"   label="车队" align="center" width="120" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="vehicleCarry" label="载重（吨）"  align="center" :formatter="emptyFn" ></el-table-column>
                  <el-table-column prop="driverName"    label="司机" align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="firstTareTime" label="过皮时间" align="center" width="110" :formatter="emptyFn">
                    <template slot-scope="scope">
                        <span>{{scope.row.firstTareTime | dateFormat}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="firstTare"    label="皮重（吨）" align="center" :formatter="emptyFn"></el-table-column>
                </el-table>
                <!-- 分页 10,25,50,100-->
                <!-- <div style="margin-left:28px;">
                  <el-pagination background
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="heTongFrom.pageNo"
                    :page-sizes="[10,25,50,100]"
                    :page-size="heTongFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="heTongFrom.total">
                  </el-pagination>
                </div>-->
        </div>
      </span>
      <div style="margin-left:30px;">
          已选车数:<span>{{yiXuanCheShu}}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="queDingClick" size='mini'>确定</el-button>
        <el-button @click="cheLiangQuXiaoClick" size='mini'>关闭</el-button>
      </span>
    </el-dialog>
    <!-- 库存详情 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="kuCunMark"
    @close="closeDialog"
    width="900px"
    center>
      <span>
        <div class="addinpBox">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>垛位号：</span>
                <span style="font-weight: 700;">{{kuCunDuoWei}}</span>
                <el-table
                  :data="kuCunTableList"
                  ref="kuCunTableList"
                  border
                  bordersize="mini"
                  style="width:95%;margin-top:10px;margin-left:4%;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column  type="index" prop="" width="55" label="序号" align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="contractNo"    label="合同号" align="center"  :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="contractInventory"   label="库存（吨）" align="center"  :formatter="emptyFn"></el-table-column>
                  <el-table-column prop="availableContractInventory" label="可装配（吨）"  align="center" :formatter="emptyFn" ></el-table-column>
                </el-table>
                <!-- 分页 10,25,50,100-->
                <!-- <div style="margin-left:28px;">
                  <el-pagination background
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="heTongFrom.pageNo"
                    :page-sizes="[10,25,50,100]"
                    :page-size="heTongFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="heTongFrom.total">
                  </el-pagination>
                </div>-->
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="KuCunDetermineClick" size='mini'>确定</el-button> -->
        <el-button @click="KuCunQuXiaoClick" size='mini'>关闭</el-button>
      </span>
    </el-dialog>
      <div  class="btn">
        <el-button type="primary" @click="finishAllData" :disabled="wanChengBtn">完成派车</el-button>
      </div>
    </div>

  </div>
</template>
<script>
import {
  paiCheDuoWeiData, // 获取垛位、可发库存、待发车次
  paiCheGetCarAndDriver, // 获取选择车辆数据
  jiChuGuanLiChangeFleet, // 选择车辆-车队下拉框
  cyManualSendCar, // 完成派车
  getSelectVehicleInfo, //
  getBigPlanInfo,
  bigPlanManualSendCar, // 派车
  getManualDispatchCarInfo //获取集港计划页面点击派车获取
} from '@/api/zhb'
import { emptyFn } from '@/utils/util'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP001B00H'],
      emptyFn: emptyFn,
      title: '',
      h: '500px',
      keHuName: '',
      heTongNum: '',
      planNo: '',
      shengYuLiang: '',
      total: 0,
      cheLiangFrom:[],
      tableList:[],
      duoWeiOptions: [],
      fleetOptions: [], // 车队
      tableData: [],
      carTableList: [], // 选择车辆数据
      tableList: [],
      // 查看
      seeMark: false,
      heTongFrom: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      // 选择车辆
      cheLiangMark: false,
      cheLiangFrom: {
        value: '',
        chePai: ''
      },
      yiXuanCheShu: 0,
      // 车辆选择
      carSelectionNum: '',
      baoCunData: {}, // 完成派车保存数据
      allPositions: '',
      wanChengBtn: true, // 按钮初始化禁用
      cargoInfoList:[], // 跺位信息列表
      dropDownCargoList:[], //跺位下拉列表
      plan:{}, //计划信息
      surplusWeight:'', //剩余量
      waybillForm:{
        flowtoType:''
      },
      planNo:'',
      // 库存详情
      kuCunMark:false,
      kuCunDuoWei:'',
      kuCunTableList:[],
      wareContractList:{},
      inventoryArr:[],
      availableInventoryArr:[],
      keFaKuCun:'',
      keZhuangPei:''
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/planManagement')
    this.planNo=this.$route.params.planNo
    if (this.planNo==null||this.planNo==undefined||this.planNo=='') {
      this.planNo=localStorage.getItem('planIdForManualSendCar')
    }
    this.getPageInfo()
  },
  methods: {
     /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      // this.getSearchData()
    },
    // 返回
    backClick () {
      this.$router.go(-1)
    },
    // 选择车辆确定
    queDingClick () {
      this.cheLiangMark = false
      this.cheLiangFrom = {
        value: '',
        chePai: ''
      }
      this.carSelectionNum = this.$refs.carTabRef.selection
      this.tableList = this.carSelectionNum
      this.wanChengBtn = false
      // console.log(this.carSelectionNum)
    },
    // 选择车辆关闭
    cheLiangQuXiaoClick () {
      this.cheLiangMark = false
      this.cheLiangFrom = {
        value: '',
        chePai: ''
      }
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.heTongFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.heTongFrom.pageNo = val
      // this.getSearchData()
    },
    // 删除
    delClick (index, rows) {
      rows.splice(index, 1)
    },
    // 获取车辆数据
    getSearchCar () {
      getSelectVehicleInfo(this.waybillForm).then(res => {
          this.carTableList=res
      }).catch(err => {
          this.$message.error(err.message)
      })
    },
    // 点击车辆查询
    carSearchClick () {
      this.getSearchCar()
    },
    // 点击选择车辆
    xuanZeCheLiang () {
      this.title = '选择车辆'
      // 车队下拉框
      jiChuGuanLiChangeFleet().then(res => {
        this.fleetOptions = res
        this.cheLiangMark = true
        // console.log(this.fleetOptions)
      }).catch(err => {
        this.$message.error(err.message)
      })
      this.getSearchCar()
      // this.yiXuanCheShu = this.$refs.carTabRef.selection.length
    },
    handleSelectionChange (val) {
      this.yiXuanCheShu = val.length
      // console.log(val.length, '////')
    },
    // 保存组装数据
    finishAllData () {
      if (this.tableList.length==0) {
        this.$message.error('请先选择车辆')
        return
      }
      let obj = {
        waybillList:[],
        wareHouseContractMap:this.wareContractList
      }
      let carLostPosition=''
      this.tableList.forEach((item, index) => {
        if (item.positions==null||item.positions==undefined||item.positions.length==0) {
            carLostPosition+=item.vehicleNo
            if (index!=this.tableList.length-1) {
              carLostPosition+=','
            }
        }
        let param={
          driverId: item.driverId,
          driverMobile: item.driverMobile,
          driverName: item.driverName,
          fleetCode: item.fleetCode,
          fleetName: item.fleetName,
          positions: item.positions,
          vehicleCarry: item.vehicleCarry,
          vehicleFlow: item.vehicleFlow,
          vehicleId: item.vehicleId,
          vehicleNo: item.vehicleNo
        }
        obj.waybillList.push(param)
      })
      if (carLostPosition!='') {
        this.$message.error(`请给车牌号【${carLostPosition}】分配跺位`)
        return
      }
      if (obj.waybillList.length==0) {
        this.$message.error('请先选择车辆')
        return
      }
      this.wanChengBtn = true
      bigPlanManualSendCar(this.planNo,obj).then(res => {
          this.wanChengBtn = false
          this.$message.success('派车成功')
          this.$router.push('/planManagement')
      }).catch(err => {
        this.wanChengBtn = false
        this.$message.error(err.message)
      })
      
    },
    closeDialog(){
      this.carTableList=[]
      this.yiXuanCheShu=0
      this.waybillForm={
        flowtoType:this.plan.flowtoType,
        // customerCode:this.plan.customerCode
      }
    },
    // 数组求和
    sum (arr) {
      var s = 0
      arr.forEach(function (val, idx, arr) {
        s += val
      }, 0)
      return s
    },
    // 获取所有信息接口
    getPageInfo(){
      let params={
          planNo:this.planNo
      }
      if (this.planNo==null||this.planNo==undefined||this.planNo==''){
        this.$router.push({ 
          name: 'planManagement'
        }) 
        this.$message.error("没有获取到计划，请重新选择计划")
        return
      }
       getBigPlanInfo(this.planNo).then(res => {
         localStorage.setItem('planIdForManualSendCar', this.planNo) 
          this.plan=res.plan
          // console.log(this.plan)
          this.cargoInfoList=res.cargoInfoList
          this.surplusWeight=res.surplusWeight
          this.dropDownCargoList=res.dropDownCargoList
          this.waybillForm.flowtoType=this.plan.flowtoType
          // this.waybillForm.customerCode=this.plan.customerCode
          this.wareContractList = res.wareContractList
          this.inventoryArr = []
          this.availableInventoryArr = []
          this.cargoInfoList.forEach((item,index) =>{
            this.inventoryArr.push(item.inventory)
            this.availableInventoryArr.push(item.availableInventory)
          })
          this.keFaKuCun = this.sum(this.inventoryArr).toFixed(3)
          this.keZhuangPei = this.sum(this.availableInventoryArr).toFixed(3)
        }).catch(err => {
          this.$router.push({
            name:'planManagement'
          })
          this.$message.error(err.message)
        })
    },
    // 点击库存详情
    kuCunDetails(row){
      this.kuCunMark = true
      this.title = '库存详情'
      this.kuCunDuoWei = row.wareHouse
      this.kuCunTableList = row.contractMap
    },
    // 点击库存弹框确定
    KuCunDetermineClick(){
      this.kuCunMark = false
    },
    // 点击库存取消
    KuCunQuXiaoClick(){
      this.kuCunMark = false
    }
  }
}
</script>
<style scoped lang='less'>
.inpBox{
  margin: 10px 0 0 -30px;

}
.titleText{
  margin-left: 10px;
}
 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
  
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.btn{
    width: 280px;
    // border: solid 1px;
    margin: 50px auto;
}
</style>
